import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { PartnerCompanyAddedToProject } from 'api/notifications/meta';
import { Avatar } from 'components/atoms/avatar';
import { Strong } from '../basics';
import { Causer } from './causer';
import { ContainedList } from './contained-list';

export const PartnerCompanyAddedToProjectView: FC<{
  meta: PartnerCompanyAddedToProject;
}> = ({ meta: { by, companyList } }) => {
  const companies = useMemo(
    () =>
      companyList.map((company) => (
        <>
          <Avatar
            size="small"
            name={company.companyName}
            src={company.companyLogoUrl}
          />
          <Strong>{company.companyName}</Strong>
        </>
      )),
    [companyList],
  );

  return (
    <FormattedMessage
      id="notifications.messages.partner_added_to_project"
      values={{
        causer: <Causer user={by} />,
        company: <ContainedList items={companies} />,
      }}
    />
  );
};
